import { render, staticRenderFns } from "./ClientesColaborador.vue?vue&type=template&id=529e4bb2"
import script from "./ClientesColaborador.vue?vue&type=script&lang=js"
export * from "./ClientesColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports